import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import AvatarIcon from '../../components/atoms/AvatarIcon';
import css from './ConnectionLogo.css';

export const ConnectionLogoSizes = {
    SMALL: 'small',
    MEDIUM: 'medium',
};

const ConnectionLogo = ({ Logo, connected, size = ConnectionLogoSizes.MEDIUM }) => (
    <span className={classNames(css.wrapper, css[size])}>
        <AvatarIcon className={css.tile}>
            <Logo className={css.logo} />
        </AvatarIcon>
        {connected && <span className={css.connectedDot} />}
    </span>
);

ConnectionLogo.propTypes = {
    Logo: PropTypes.elementType.isRequired,
    connected: PropTypes.bool.isRequired,
    size: PropTypes.oneOf(Object.values(ConnectionLogoSizes)),
};

export default ConnectionLogo;
